import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Phone, Calendar } from 'lucide-react';
import { mockData } from '../mock';

export const Hero = ({ onContactClick }) => {
  const openCalendly = () => {
    if (window.Calendly) {
      window.Calendly.initPopupWidget({ url: 'https://calendly.com/taiebnatana/30min' });
    }
    return false;
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-stone-50 via-emerald-50/30 to-stone-100">
      {/* Decorative elements */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(52,211,153,0.1),transparent_50%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_80%,rgba(167,243,208,0.15),transparent_50%)]" />
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 text-center">
        <div className="space-y-8 animate-fade-in">
          {/* Logo */}
          <div className="flex justify-center mb-8">
            <img 
              src="/logo.jpeg" 
              alt="Mon diag Immo" 
              className="w-32 h-32 md:w-40 md:h-40 rounded-full shadow-2xl hover:scale-105 transition-transform duration-300" 
            />
          </div>

          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/80 backdrop-blur-sm border border-emerald-200/50 shadow-sm">
            <div className="w-2 h-2 rounded-full bg-emerald-600 animate-pulse" />
            <span className="text-sm font-medium text-stone-700">Diagnostiqueuse Certifiée</span>
          </div>

          {/* Main Title */}
          <h1 className="text-6xl md:text-7xl lg:text-8xl font-bold tracking-tight">
            <span className="bg-gradient-to-r from-stone-900 via-stone-800 to-emerald-900 bg-clip-text text-transparent whitespace-nowrap">
              MonDiagImmo
            </span>
          </h1>

          {/* Subtitle */}
          <p className="text-2xl md:text-3xl text-stone-700 font-light max-w-3xl mx-auto">
            {mockData.hero.subtitle}
          </p>

          {/* Description */}
          <p className="text-lg text-stone-600 max-w-2xl mx-auto leading-relaxed">
            {mockData.hero.description}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-6">
            <Button 
              size="lg" 
              onClick={openCalendly}
              className="group bg-emerald-700 hover:bg-emerald-800 text-white px-8 py-6 text-lg rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
            >
              <Calendar className="mr-2 w-5 h-5" />
              Prendre rendez-vous
            </Button>
            <Button 
              size="lg" 
              onClick={onContactClick}
              className="group bg-stone-700 hover:bg-stone-800 text-white px-8 py-6 text-lg rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
            >
              {mockData.hero.cta}
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button 
              size="lg" 
              variant="outline"
              className="border-2 border-stone-300 hover:border-emerald-700 hover:bg-emerald-50 px-8 py-6 text-lg rounded-full transition-all duration-300"
            >
              <Phone className="mr-2 w-5 h-5" />
              {mockData.contact.phone}
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 rounded-full border-2 border-stone-400 flex items-start justify-center p-2">
          <div className="w-1.5 h-3 bg-stone-400 rounded-full animate-scroll" />
        </div>
      </div>
    </section>
  );
};